import { render, staticRenderFns } from "./huanmotiaoji.vue?vue&type=template&id=486e60bc&scoped=true&"
import script from "./huanmotiaoji.vue?vue&type=script&lang=js&"
export * from "./huanmotiaoji.vue?vue&type=script&lang=js&"
import style0 from "./huanmotiaoji.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./huanmotiaoji.vue?vue&type=style&index=1&id=486e60bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e60bc",
  null
  
)

export default component.exports